export { SignalRConnectionMock } from './services/testing/signalr.connection.mock';
export { SignalRConnectionMockManager } from './services/testing/signalr.connection.mock.manager';
export { ConnectionStatus } from './services/connection/connection.status';
export { ConnectionStatuses } from './services/connection/connection.statuses';
export { BroadcastEventListener } from './services/eventing/broadcast.event.listener';
export { SignalRConnection } from './services/connection/signalr.connection';
export { ConnectionTransport } from './services/connection/connection.transport';
export { ConnectionTransports } from './services/connection/connection.transports';
export { SignalR } from './services/signalr';
export { SignalRConfiguration } from './services/signalr.configuration';
export { SignalRModule } from './modules/signalr-module';
//# sourceMappingURL=ng2-signalr.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-signalr/src/ng2-signalr.js
// module id = 571
// module chunks = 0